import React from "react";
import { withStyles } from "@material-ui/core/styles";
import LibraryAddIcon from "@material-ui/icons/LibraryAddOutlined";

const styles = (theme) => ({
  label: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
    marginLeft: 4,
    marginRight: 15,
    [theme.breakpoints.down("md")]: {
      fontSize: "9px",
    },
  },
  muiIconContainer: {
    color: theme.HeaderDefaultTextColor,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRight: `1px solid ${theme.headerBorderColor}`,
    "&:hover": {
      color: theme.HeaderSelectedText,
    },
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      marginRight: 15,
    },
  },
});

const ShipmentSelection = ({ classes, url }) => (
  <div
    className={classes.muiIconContainer}
    data-automationid="shipment-selection"
    onClick={() => window.open(url, "_blank")}
  >
    <div>
      <LibraryAddIcon />
    </div>
    <div className={classes.label}>
      Shipments
      <br />
      Selection
    </div>
  </div>
);

export default withStyles(styles)(ShipmentSelection);
